<template>
    <div class="absolute left-0 top-0 w-0 h-0 invisible">
        <Wallet/>
        <CreateUser/>
        <ChangePassword/>
        <UpdateBalance/>
        <EditWallet/>
    </div>
</template>

<script>
    export default {
        components: {
            Wallet: () => import('./modals/Wallet.vue'),
            CreateUser: () => import('./modals/CreateUser.vue'),
            ChangePassword: () => import('./modals/ChangePassword.vue'),
            UpdateBalance: () => import('./modals/UpdateBalance.vue'),
            EditWallet: () => import('./modals/EditWallet.vue'),
        }
    }
</script>